import React from 'react';
import { StackChildren, StackChildrenSize, Text, } from '@doordash/design-language';
import { VoucherCardContainer, VoucherCardContent } from './VoucherCardStyles';
import { getVoucherValidPeriod } from '../utils/voucherDateTimeHelper';
import i18n from '../../../i18n';
import { CurrencyCode, formatMoney } from '@doordash/lib-i18n';
export var VoucherCard = function (_a) {
    var _b;
    var voucher = _a.voucher, cardBackgroundColor = _a.cardBackgroundColor, punchedHoleColor = _a.punchedHoleColor;
    var currency = CurrencyCode.USD;
    var userLocale = i18n.getCurrentLocale();
    var unitAmount = (_b = voucher === null || voucher === void 0 ? void 0 : voucher.maximumAllotment) === null || _b === void 0 ? void 0 : _b.unitAmount;
    var voucherAllotmentDisplay = unitAmount
        ? formatMoney({
            currency: currency,
            userLocale: userLocale,
            unitAmount: unitAmount,
            concise: false,
        })
        : null;
    if (!voucher) {
        return null;
    }
    var voucherValidPeriod = getVoucherValidPeriod(voucher);
    return (React.createElement(VoucherCardContainer, { cardBackgroundColor: cardBackgroundColor, punchedHoleColor: punchedHoleColor },
        React.createElement(VoucherCardContent, null,
            React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.PageTitle1 }, voucherAllotmentDisplay || ''),
            React.createElement(StackChildren, { size: StackChildrenSize.XxxSmall },
                !!(voucher === null || voucher === void 0 ? void 0 : voucher.name) && (React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.Title2 }, voucher.name)),
                React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.Body2 }, voucherValidPeriod)))));
};
